import { useI18n } from '@monorepo/i18n';
import { UserBriefInfo } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import FormHeader from '../../common/FormHeader';
import MerchandiserForm from './components/MerchandiserForm';
import useAddMerchandiser from '../../hooks/useAddMerchandiser';
import useUser from '../../hooks/useUser';
import { Roles } from '../../constants';
import { useCallback } from 'react';
import { QUERY_KEYS } from '@monorepo/helpers/index';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useNotifications } from '@monorepo/notification/index';

const UserAddMerchandiser = () => {
  const { t } = useI18n();
  const { data } = useUser();
  const { mutate } = useAddMerchandiser();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { successNotification } = useNotifications();

  const onSuccess = useCallback(() => {
    successNotification(t('createUser.form.success'));
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
    navigate(`/personal-office/personal-info/merchandisers`);
  }, [t, successNotification, queryClient, navigate]);

  const onSubmit = (itemForm: UserBriefInfo.AsObject) => {
    const merchandiser = {
      ...itemForm,
      role: Roles.MERCHANDISER,
      changePassword: false,
      login: itemForm.phoneNumber,
      supplier: {
        id: data?.id
      }
    };
    mutate(merchandiser, { onSuccess });
  };

  return (
    <>
      <FormHeader title={t('add.merchandiser.title')} />
      <MerchandiserForm onSubmit={onSubmit} />
    </>
  );
};

export default UserAddMerchandiser;
